import {Sortable} from '../_models/sortable';

export function reorder(list: Sortable[], event) {
    if (!!list && list.length > 1) {
        const itemMove = list.splice(event.detail.from, 1)[0];
        list.splice(event.detail.to, 0, itemMove);
        let i = 0;
        list.forEach(s => s.sortOrder = i++);
    }
    event.detail.complete();
}

export function sortAlphabetical(list: any[], sortField: string): Sortable[] {
    if (!!list && list.length > 1 && sortField) {
        const fields = sortField.split('.');
        list = list.sort((a, b) => {
            let aName = getField(a, fields);
            if (!!aName) {
                aName = aName.toLowerCase();
            }

            let bName = getField(b, fields);
            if (!!bName) {
                bName = bName.toLowerCase();
            }

            return !!aName && !!bName ? aName.localeCompare(bName) : 0;
        });
        let sortIndex = 0;
        list.forEach(s => s.sortOrder = sortIndex++);
    }
    return list;
}

export function filterList(list: any[], search: string, filterField: string): Sortable[] {
    if (!!list && list.length > 1 && !!search && filterField) {
        const fields = filterField.split('.');
        return list.filter(a => {
            const val = getField(a, fields);
            return (!!val && val.toLowerCase().includes(search.toLowerCase()));
        });
    } else {
        return [...list];
    }
}

export function getField(item: any, fields: string[]): any {
    if (!!item && !!fields) {
        if (fields.length === 0) {
            return item;
        } else {
            return getField(item[fields[0]], [...fields].splice(1));
        }
    } else {
        return null;
    }
}

export function sortBySortOrder(temp: any[]) {
    return temp.sort((a: any, b: any) => a.sortOrder - b.sortOrder);
}

export function groupAndSortModifiers(modifiers: any[]) {
    if (!!modifiers && modifiers.length > 0) {
        const grouping = modifiers.reduce((acc, m) => {
            if (!m.selectionRequired || !m.defaultModifier) {
                const name = !!m.selectionName ? m.selectionName : 'Optional Modifiers';
                let group = acc.find(g => g.name === name);
                if (!group) {
                    group = {
                        name,
                        sortOrder: !!m.selectionSortOrder || m.selectionSortOrder === 0 ? m.selectionSortOrder : 9999,
                        modifiers: [m]
                    };
                    acc.push(group);
                } else {
                    group.modifiers.push(m);
                    group.modifiers = sortBySortOrder(group.modifiers);
                }
            }
            return acc;
        }, []);
        return sortBySortOrder(grouping);
    }
    return [];
}
